import _Object$keys from "@babel/runtime-corejs3/core-js/object/keys";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js/object/get-own-property-symbols";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptor";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js/object/define-property";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js/instance/filter";
import _includesInstanceProperty from "@babel/runtime-corejs3/core-js/instance/includes";
import _spliceInstanceProperty from "@babel/runtime-corejs3/core-js/instance/splice";
import _indexOfInstanceProperty from "@babel/runtime-corejs3/core-js/instance/index-of";
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapActions, mapGetters } from "vuex";
import { LOAD_CAMPAIGN_STATISTICS, LOAD_MARKETING_CAMPAIGNS } from "../../store/marketing/marketing-actions";
import { CAMPAIGNS, GET_CAMPAIGN_STATISTICS } from "../../store/marketing/marketing-getters";
import MarketingCampaignTableLoader from "./marketing-campaign-table-loader";
import Navbar from "@Shared/components/general/nav-bar.vue";
import MarketingCampaignStats from "./marketing-campaign-stats";
import NotificationPopover from "@Shared/components/general/notification-popover";
import SimpleButton from "@Shared/components/buttons/simple-button.vue";
import { CAMPAIGNS_STATUS } from "@Shared/@Utils/constants";
import { defineComponent } from "@vue/composition-api";
export default defineComponent({
  name: "CampaignsTable",
  components: {
    MarketingCampaignTableLoader,
    Navbar,
    MarketingCampaignStats,
    NotificationPopover,
    SimpleButton
  },
  data() {
    return {
      loading: true,
      loadingStats: "",
      search: "",
      columns: ["name", "deliveryDateIndicator", "deliveryDate", "actions"],
      currentTab: "all",
      openedStats: []
    };
  },
  computed: _objectSpread(_objectSpread({}, mapGetters("MarketingStore", [CAMPAIGNS, GET_CAMPAIGN_STATISTICS])), {}, {
    tabs() {
      return [{
        label: this.$tc("global.words.all", 2),
        value: "all"
      }, {
        label: this.$t("global.words.scheduled"),
        value: "active"
      }, {
        label: this.$tc("global.words.sent", 2),
        value: "sent"
      }, {
        label: this.$tc("global.words.cancelled", 2),
        value: "cancelled"
      }];
    },
    isDataEmpty() {
      return this.filteredCampaigns.length;
    },
    options() {
      return {
        uniqueKey: "campaignId",
        filterable: false,
        sortIcon: {
          base: "fa",
          up: "fa-sort-up",
          down: "fa-sort-down",
          is: "fa-sort"
        },
        tabbable: false,
        skin: "table table-hover",
        perPage: 999999,
        texts: {
          noResults: this.$t("tables.messages.emptyCampaigns")
        },
        showChildRowToggler: false
      };
    },
    campaignsStatus() {
      return CAMPAIGNS_STATUS();
    },
    filteredCampaigns() {
      var _context;
      const campaigns = this.currentTab === "all" ? this.CAMPAIGNS : _filterInstanceProperty(_context = this.CAMPAIGNS).call(_context, campaign => campaign.status === this.currentTab) || this.CAMPAIGNS;
      return this.search !== "" ? _filterInstanceProperty(campaigns).call(campaigns, campaign => {
        var _context2;
        return _includesInstanceProperty(_context2 = campaign.name.toLowerCase()).call(_context2, this.search.toLowerCase());
      }) : campaigns;
    }
  }),
  mounted() {
    this.load();
  },
  methods: _objectSpread(_objectSpread({}, mapActions("MarketingStore", [LOAD_MARKETING_CAMPAIGNS, LOAD_CAMPAIGN_STATISTICS])), {}, {
    async load() {
      this.loading = true;
      await this.LOAD_MARKETING_CAMPAIGNS({
        all: true
      });
      this.loading = false;
    },
    handleTabChange(tab) {
      this.currentTab = tab;
    },
    campaignDetailsLink({
      campaignId
    }) {
      return {
        name: "marketing-campaign-details",
        params: {
          campaignId
        }
      };
    },
    async showCampaignResults({
      campaignId
    }) {
      var _context3;
      if (_includesInstanceProperty(_context3 = this.openedStats).call(_context3, campaignId)) {
        var _context4, _context5;
        _spliceInstanceProperty(_context4 = this.openedStats).call(_context4, _indexOfInstanceProperty(_context5 = this.openedStats).call(_context5, campaignId), 1);
      } else {
        this.loadingStats = campaignId;
        await this.LOAD_CAMPAIGN_STATISTICS(campaignId);
        this.loadingStats = "";
        this.openedStats.push(campaignId);
      }
      this.$refs.campaignsTable.toggleChildRow(campaignId);
    },
    goToCampaignDetails(link) {
      this.$router.push(link);
    }
  })
});